import { Injectable, EventEmitter } from '@angular/core';
import { SideBarIndex } from './side-bar.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SideBarService {
  private tabSelected$ = new BehaviorSubject<SideBarIndex>(SideBarIndex.None);

  constructor() { }

  get tabSelected() {
    return this.tabSelected$.asObservable();
  }

  handleChangeSideBarTab(tab: SideBarIndex, autoCollapse = true) {
    if (tab === this.tabSelected$.value && autoCollapse) {
      this.tabSelected$.next(SideBarIndex.None);
    } else {
      this.tabSelected$.next(tab);
    }
  }

  close() {
    this.tabSelected$.next(SideBarIndex.None);
  }
}
